/* @flow */
import React from 'react';
import './tab-control.css';

function TabControl(props) {
  let impressionsLiClassName = 'impressions';
  let viewsLiClassName = 'views';
  if (props.isImpressions)
    impressionsLiClassName += ' selected';
  else
    viewsLiClassName += ' selected';
  return (
    <ul className="TabControl">
      <li className={impressionsLiClassName}>
        <a href='impressions' onClick={props.onImpressionsClick}>
          <span>Most</span>
          <span>Impressions</span>
        </a>
      </li>
      <li className={viewsLiClassName}>
        <a href='views' onClick={props.onViewsClick}>
        <span>Most</span>
        <span>Views</span>
        </a>
      </li>
    </ul>
  );
}

export default TabControl;



// WEBPACK FOOTER //
// ./src/app/stats/container/impressions-and-views/tab-control.js